import * as React from "react";

function IconREAFreemium(props) {
  return (
    <svg width={72} height={72} fill="none" {...props}>
  <circle
    cx={35.625}
    cy={36.375}
    r={34.875}
    fill="url(#prefix__paint0_linear_1742_4152)"
  />
  <circle
    cx={35.625}
    cy={36.375}
    r={34.375}
    stroke="#fff"
    strokeOpacity={0.16}
  />
  <path
    d="M45.027 24.484c.923-1.565 1.34-3.282 1.117-4.742-.163-1.067-.65-1.926-1.41-2.483-.757-.558-1.72-.768-2.789-.606-1.725.262-3.53 1.472-4.827 3.237a9.415 9.415 0 00-1.247 2.291 9.356 9.356 0 00-1.245-2.291c-1.302-1.767-3.11-2.977-4.833-3.237-1.064-.161-2.029.05-2.784.606-.76.557-1.247 1.416-1.41 2.483-.222 1.46.195 3.177 1.118 4.742H19v9.545h1.632v14.37c0 1.766 1.438 3.2 3.206 3.2h23.9c1.763 0 3.199-1.434 3.199-3.199V34.03h1.8v-9.545h-7.71zm-7.033-3.95c1.13-1.537 2.669-2.586 4.114-2.805.777-.117 1.462.024 1.981.407l.002.001c.52.382.859.994.977 1.769.212 1.386-.283 3.084-1.327 4.579h-7.248c.038-1.272.57-2.684 1.501-3.95zm-11.318-.628c.118-.775.456-1.387.979-1.77.519-.383 1.203-.524 1.976-.408 1.444.219 2.984 1.268 4.118 2.807.93 1.263 1.46 2.674 1.497 3.95h-7.244c-1.044-1.496-1.538-3.193-1.326-4.58zM21.72 48.4V34.03h9.514v16.482h-7.397A2.117 2.117 0 0121.72 48.4zm17.528-14.37v16.482h-6.926V34.03h6.926zm8.488 16.482h-7.4V34.03h9.511V48.4a2.114 2.114 0 01-2.11 2.112zM51.65 32.94h-1.802v.002H21.721v-.002h-1.633v-7.367H51.65v7.367z"
    fill="#fff"
    stroke="color(display-p3 .9686 .9608 .9804)"
    strokeWidth={1.2}
  />
  <g clipPath="url(#prefix__clip0_1742_4152)">
    <path
      d="M54.715 20.41l-2.998.752-.47-.778 1.47-2.617-1.372-2.49.504-.703 2.34.576 1.942-2.17.78.192.712 2.823 2.34.577.12.857-2.371 1.567.088 3.002-.777.47-2.308-2.058z"
      fill="url(#prefix__paint1_linear_1742_4152)"
    />
    <path
      d="M56.5 13.586l.638 2.531.074.292 2.303.567.03.21-2.109 1.393-.233.154.01.278.08 2.709-.215.13-2.03-1.813-.198-.176-.257.064-2.64.662-.13-.214 1.33-2.361.138-.242-.135-.245-1.221-2.213.123-.172 2.304.567.2-.224 1.741-1.946.197.049z"
      stroke="#000"
      strokeOpacity={0.04}
    />
  </g>
  <defs>
    <linearGradient
      id="prefix__paint0_linear_1742_4152"
      x1={18.188}
      y1={66.581}
      x2={53.063}
      y2={6.169}
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="color(display-p3 .8076 .0787 .7468)" />
      <stop offset={0.17} stopColor="color(display-p3 .8076 .0787 .7468)" />
      <stop offset={0.56} stopColor="color(display-p3 .9608 .1176 .5176)" />
      <stop offset={1} stopColor="color(display-p3 .9608 .1176 .5176)" />
    </linearGradient>
    <linearGradient
      id="prefix__paint1_linear_1742_4152"
      x1={56.521}
      y1={13.076}
      x2={54.37}
      y2={21.815}
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="color(display-p3 .9993 .9564 .9769)" />
      <stop offset={1} stopColor="color(display-p3 1 .9457 .9951)" />
    </linearGradient>
    <clipPath id="prefix__clip0_1742_4152">
      <path
        fill="#fff"
        transform="rotate(13.831 -23.392 220.985)"
        d="M0 0h9v9H0z"
      />
    </clipPath>
  </defs>
</svg>




  );
}

const MemoIconREAFreemium = React.memo(IconREAFreemium);
export default MemoIconREAFreemium;
